import React from "react";

const COLORS = {
  amethyst: "#6D4C92",
  darkAmethyst: "#2D1B44",
};

// /letter — welcome page. (The old "All Country Modules" grid was removed in
// the Thai-only build.)
const Letter: React.FC = () => {
  return (
    <div className="flex-1 w-full overflow-y-auto bg-[#f7f7fb]">
      <div className="mx-auto flex min-h-[60vh] w-full max-w-[1100px] flex-col items-center justify-center px-4 py-10 text-center sm:px-6 lg:px-8">
        <div
          className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl text-3xl"
          style={{ backgroundColor: `${COLORS.amethyst}15` }}
          aria-hidden="true"
        >
          ✉️
        </div>
        <h1
          className="text-2xl font-bold tracking-tight sm:text-3xl"
          style={{ color: COLORS.darkAmethyst }}
        >
          ยินดีต้อนรับสู่ Letter
        </h1>
      </div>
    </div>
  );
};

export default Letter;
